import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState } from '../../../stores/types/types';
import * as ModalActions from '../../../stores/actions/modal';
import { BulkDeleteShots } from '../../../connection/shots';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';

export default function BulkDeleteShotsConfirmation() {
	const dispatch = useDispatch();
	const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting);
	const shots = useSelector((state: GreenroomState) => state.ShotsReducer.shots);
	const segments = useSelector((state: GreenroomState) => state.SegmentsReducer.segments);
	const modalData = useSelector((state: GreenroomState) => state.ModalReducer.modalData);

	const shotIds: number[] = modalData?.shotIds ?? [];

	const headerText = useMemo(() => {
		const count = shotIds.length;
		const selectedShots = shots.filter(s => shotIds.includes(s.shot_id));
		const segmentIds = new Set(selectedShots.map(s => s.segment_id).filter(Boolean));
		const segmentCount = segmentIds.size;

		if (segmentCount === 1) {
			const segment = segments.find(s => segmentIds.has(s.id));
			const segmentName = segment?.name ?? 'segment';
			return `Are you sure you want to delete ${count} shot${count === 1 ? '' : 's'} from "${segmentName}"?`;
		}

		if (segmentCount > 1) {
			return `Are you sure you want to delete ${count} shots across ${segmentCount} segments?`;
		}

		return `Are you sure you want to delete ${count} shot${count === 1 ? '' : 's'}?`;
	}, [shotIds, shots, segments]);

	const handleDelete = async () => {
		if (!meeting) return;
		await BulkDeleteShots(meeting.meeting, shotIds);
		dispatch(ModalActions.setModalOpen(false));
	};

	const closeModal = () => {
		dispatch(ModalActions.setModalOpen(false));
	};

	return (
		<MultiButtonConfirmationModal
			headerText={headerText}
			bodyText="Once deleted, the shots cannot be recovered."
			firstButtonText={`Delete ${shotIds.length} Shot${shotIds.length === 1 ? '' : 's'}`}
			secondButtonText="Cancel"
			firstButtonAction={handleDelete}
			secondButtonAction={closeModal}
			isOpen
		/>
	);
}
